import { convert_to_fa } from "@src/functions/farsi";
import { getSortedTopicsByTab } from "@src/getSortedTopicsByTab";
import { ITabBarItemProps } from "@src/types";
import { useAtomSelector } from "@zedux/react";
import cx from "classix";
import { useMemo } from "react";

export default function TabBarItem({ tab, activeTab, setTab, context }: ITabBarItemProps) {
	const topics = useAtomSelector(getSortedTopicsByTab, context, tab.key, false)
	const unseenCount = useMemo(() => {
		if (!topics || topics.length === 0) return 0
		return topics.reduce((count, topic) => {
			return count + (Number(topic.unseen_count) || 0)
		}, 0)
	}, [topics])

	return (
		<div
			key={tab.key}
			className={cx(
				'flex grow min-w-16  transition-colors items-center py-2 cursor-pointer text-sm font-medium justify-center transition-none rounded-lg relative',
				tab.key === activeTab ? 'bg-primary-00 text-white hover:bg-primary-02 fill-white' : 'hover:bg-white/70 text-gray-400 fill-secondary-00'
			)}
			onClick={() => setTab(tab.key)}
		>
			<span className='size-4'>
				{tab.icon}
			</span>
			{!!tab.label && <span className="mx-2 text-xs">{tab.label}</span>}
			{unseenCount > 0 && <span className="absolute top-2 leading-0 left-2 text-xs bg-red-500 text-white rounded-full size-4 flex justify-center items-center">{convert_to_fa(unseenCount)}</span>}
		</div>
	);
}
